module.exports = __webpack_public_path__ + "img/part3-6.c79be3ab.png";